type Trend = 'under' | 'over' | 'equal';

export const compareStatistics = (current: number, median: number): Trend => {
	if (current > median) {
		return 'over';
	}
	if (current < median) {
		return 'under';
	}

	return 'equal';
};
